import React, { useState } from 'react';
import { toast } from 'sonner';
import studentsService from '../services/studentsService';
import { X, Check, CircleNotch } from '@phosphor-icons/react';

function ParentForm({ studentId, onSuccess, onCancel }) {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    relationship: 'father',
    phone: '',
    email: '',
    occupation: '',
    address: '',
    is_emergency_contact: false,
    custody_type: ''
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.first_name.trim() || !formData.last_name.trim()) {
      toast.error('First name and last name are required');
      return;
    }

    if (!formData.phone.trim()) {
      toast.error('Phone number is required');
      return;
    }

    try {
      setLoading(true);
      await studentsService.addParentToStudent(studentId, formData);
      toast.success('Parent added successfully!');
      onSuccess();
    } catch (error) {
      toast.error(error.message || 'Failed to add parent');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="parent-form">
      <div className="form-row">
        <div className="form-group">
          <label>First Name *</label>
          <input
            type="text"
            name="first_name"
            value={formData.first_name}
            onChange={handleChange}
            placeholder="Parent first name"
            disabled={loading}
            required
          />
        </div>
        <div className="form-group">
          <label>Last Name *</label>
          <input
            type="text"
            name="last_name"
            value={formData.last_name}
            onChange={handleChange}
            placeholder="Parent last name"
            disabled={loading}
            required
          />
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label>Relationship *</label>
          <select
            name="relationship"
            value={formData.relationship}
            onChange={handleChange}
            disabled={loading}
            required
          >
            <option value="father">Father</option>
            <option value="mother">Mother</option>
            <option value="guardian">Guardian</option>
            <option value="uncle">Uncle</option>
            <option value="aunt">Aunt</option>
            <option value="grandparent">Grandparent</option>
            <option value="other">Other</option>
          </select>
        </div>
        <div className="form-group">
          <label>Phone *</label>
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="e.g., 0501234567"
            disabled={loading}
            required
          />
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label>Custody Type</label>
          <select
            name="custody_type"
            value={formData.custody_type}
            onChange={handleChange}
            disabled={loading}
          >
            <option value="">Default (Guardian)</option>
            <option value="legal_guardian">Legal Guardian</option>
            <option value="custodial">Custodial</option>
            <option value="non_custodial">Non-custodial</option>
            <option value="emergency_only">Emergency Only</option>
          </select>
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label>Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="parent@example.com"
            disabled={loading}
          />
        </div>
        <div className="form-group">
          <label>Occupation</label>
          <input
            type="text"
            name="occupation"
            value={formData.occupation}
            onChange={handleChange}
            placeholder="e.g., Software Engineer"
            disabled={loading}
          />
        </div>
      </div>

      <div className="form-group">
        <label>Address</label>
        <input
          type="text"
          name="address"
          value={formData.address}
          onChange={handleChange}
          placeholder="Residential address"
          disabled={loading}
        />
      </div>

      <div className="form-group checkbox">
        <input
          type="checkbox"
          id="emergency_contact"
          name="is_emergency_contact"
          checked={formData.is_emergency_contact}
          onChange={handleChange}
          disabled={loading}
        />
        <label htmlFor="emergency_contact">Mark as emergency contact</label>
      </div>

      <div className="form-actions">
        <button
          type="button"
          className="btn btn-secondary"
          onClick={onCancel}
          disabled={loading}
        >
          <X size={16} /> Cancel
        </button>
        <button
          type="submit"
          className="btn btn-primary"
          disabled={loading}
        >
          {loading ? (
            <span className="button-loading">
              <CircleNotch size={16} weight="fill" className="spinner" />
              Adding...
            </span>
          ) : (
            <>
              <Check size={16} /> Add Parent
            </>
          )}
        </button>
      </div>
    </form>
  );
}

export default ParentForm;
